import '@/app/globals.css';
import type { AppProps } from 'next/app';
import Head from 'next/head';
import { ThemeProvider } from '@/context/ThemeContext';
import { AuthProvider } from '@/auth/AuthProvider'; // Import AuthProvider
import PWAInstallBanner from '@/components/Common/PWAInstallBanner';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ErrorBoundary from '@/components/Common/ErrorBoundary';
import ConnectionStatus from '@/components/Common/ConnectionStatus';



function MyApp({ Component, pageProps }: AppProps) {
  return (
    <ErrorBoundary>
      <> {/* Use Fragment to wrap Head and ThemeProvider */}
        <Head>
          <title>Data Mapper</title>
          {/* You can add other head elements here like meta tags, link tags for favicons etc. */}
          {/* Example Favicon links (ensure these files exist in /public): */}
          {/* <link rel="icon" href="/favicon.ico" /> */}
          {/* <link rel="icon" type="image/png" sizes="96x96" href="/favicon-96x96.png" /> */}
          {/* <link rel="apple-touch-icon" href="/apple-touch-icon.png" /> */}
          {/* <link rel="manifest" href="/site.webmanifest" /> */}
        </Head>
        <AuthProvider> {/* Wrap with AuthProvider */}
          <ThemeProvider>
            <Component {...pageProps} />
            <ConnectionStatus />
            <PWAInstallBanner />
          </ThemeProvider>
        </AuthProvider>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </>
    </ErrorBoundary>
  );
}

export default MyApp;
